import React from 'react'

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import useIsMobile from 'hooks/useIsMobile'

import { AlertContainer, AlertText, ActionButton } from './styled'

const ProviderDateAlert = ({ providerName, date, onAction }) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  return (
    <AlertContainer>
      <AlertText>
        {isMobile ? t('mobileNextProviderDate', { providerName, date }) : t('nextProviderDate', { providerName, date })}
      </AlertText>
      <ActionButton onClick={onAction}>{t('makeorder')}</ActionButton>
    </AlertContainer>
  )
}

ProviderDateAlert.propTypes = {
  providerName: PropTypes.string,
  date: PropTypes.string,
  onAction: PropTypes.func,
}

ProviderDateAlert.defaultProps = {
  providerName: '',
  date: '',
  onAction: () => {},
}

export default ProviderDateAlert
